import React, {Component} from 'react';
import classNames from 'classnames';
import {connectToStore} from './Provider';
import searchProducts from '../api/searchProducts';
import searchProductsCount from '../api/searchProductsCount';
import {Link} from 'gatsby';
import isNumber from 'lodash/isNumber';
import ProductCardGrid from './ProductCardGrid';
import Pagination from './Pagination';
import Reveal from '../components/Reveal';

export const PRODUCTS_PER_PAGE = 24;
export const MAX_BUTTONS = 5;

class PaginatedProductList extends Component {
	constructor() {
		super();

		this.state = {
			isLoadingProducts: true,
			isLoadingCount: true,
			products: [],
			count: 0,
		};
	}

	componentDidMount = () => {
		this.fetchPagination();
		this.fetchProducts();
	}

	fetchPagination = () => {
		this.setState({isLoadingCount: true});

		searchProductsCount(this.props.query)
			.then(({count}) => {
				this.setState({
					count: isNumber(count) ? count : 0,
					isLoadingCount: false,
				});
			})
			.catch(error => {
				console.log(error);
				this.setState({isLoadingCount: false});
			});
	}

	fetchProducts = () => {
		this.setState({isLoadingProducts: true});

		const {query, offset, limit} = this.props;

		searchProducts({
			...query,
			offset,
			limit,
		})
			.then(products => {
				this.setState({
					isLoadingProducts: false,
					products,
				});
			})
			.catch(error => {
				console.log(error);
				this.setState({isLoadingProducts: false});
			});
	}

	render() {
		const {
			isLoadingCount,
			isLoadingProducts,
			products,
			count,
		} = this.state;

		const {
			openQuickAddProduct,
		} = this.props;

		// Empty state
		if (!isLoadingCount && count === 0) {
			return this.renderEmptyState();
		}

		// Loading state
		if (
			isLoadingProducts ||
			(isLoadingCount && count === 0)
		) {
			return (
				<p className="product-results__empty color--gray-text tc">
					Loading…
				</p>
			);
		}

		const productColumns = products.map((product, index) => (
			<div
				className={classNames('col c6--sm c4--lg mb6 mb5--md', {
					[`reveal__slide reveal__slide--medium reveal__delay--${index + 3}`]: index < 6,
					'reveal__fade reveal__delay--9': index >= 6,
				})}
				key={`${index}_${product._id}`}>
				<ProductCardGrid
					title={product.title}
					slug={product.slug}
					mainImage={product.mainImage}
					brand={product.brand}
					cents={product.cents}
					compareAtCents={product.compareAtCents}
					onClickQuickAdd={() => openQuickAddProduct(product)}
				/>
			</div>
		));

		return (
			<React.Fragment>
				<Reveal>
					<div className="row gutter--none">
						{productColumns}
					</div>
				</Reveal>
				{this.renderPagination()}
			</React.Fragment>
		);
	}

	renderEmptyState() {
		const {
			clearFiltersLink
		} = this.props;

		return (
			<div className="bg--white p2 pt6 pb6">
				<div className="pt6--md pb6--md">
					<img
						className="db m--auto mb4"
						src="/images/icon-empty-state.svg"
						alt="watch empty state"
					/>
					<h2 className="tc domaine--medium mb1">
						No Results Sorry!
					</h2>
					<div className="row align--center mb4">
						<div className="col c6--lg">
							<p className="color--gray-text tc">
								Your filters returned no results. Please try removing a few filters to improve the chances of results. 
							</p>
						</div>
					</div>
					<div className="tc">
						<Link
							title="clear filters"
							to={clearFiltersLink}
							className="button--primary-black">
							Clear All Filters
						</Link>
					</div>
				</div>
			</div>
		);
	}

	renderPagination() {
		if (this.state.isLoadingCount || this.state.isLoadingProducts || this.state.count <= PRODUCTS_PER_PAGE) return;

		return (
			<Pagination
				offset={this.props.offset}
				limit={this.props.limit}
				count={this.state.count}
				onClickPage={this.props.onChangePageIndex}
			/>
		);
	}
}

const mapStateToProps = () => ({});

const mapStoreToProps = ({
	openQuickAddProduct,
}) => ({
	openQuickAddProduct,
});

export default connectToStore(mapStateToProps, mapStoreToProps)(PaginatedProductList);